<template>
    <v-container py-0 px-0 grid-list-lg style="max-width: 1240px" class="osago-insurance-conditions">
        <v-layout row wrap>
            <v-flex xs12 pt-0 pb-3>
                <h2 style="display: inline-block;">
                    Условия страхования
                    <v-progress-circular
                        v-if="childRsaInfoLoading"
                        class="ml-1"
                        indeterminate
                        color="#00ba57"
                        size="10"
                        width="2"
                    />
                </h2>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm6 md2 pt-0>
                <v-select
                    v-model="childTerm"
                    label="Срок"
                    :items="[
                        { name: '1 год', val: 12 },
                        { name: '9 мес', val: 9 },
                        { name: '6 мес', val: 6 },
                        { name: '3 мес', val: 3 },
                        { name: '2 мес', val: 2 },
                        { name: '1 мес', val: 1 },
                    ]"
                    item-value='val'
                    item-text='name'
                    class="pt-0"
                    @change="dataChanged"
                ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md2 pt-0>
                <osago-date
                    inputClass="pt-0"
                    label="Дата начала"
                    v-model="childDateStart"
                    :yearStarting="false"
                    :min="dateMin"
                    :max="dateStartMax"
                    @change="dataChanged"
                />
            </v-flex>

            <v-flex xs12 md4 py-0 v-if="!dateOldPolis">
                <p style="padding-top: 20px;">
                    Дата начала действия не ранее {{ dateMin.split('-').reverse().join('.') }}

                    <img class="tip-icon" src="/svg/q.svg" alt=""
                            data-tippy-animateFill="false"
                            data-tippy-animation="scale"
                            data-tippy-content=
                                "Дата начала полиса Е-ОСАГО может быть установлена не ранее, чем на следующий день после даты оформления.
Для оформления договора более ранней датой вы можете обратиться в <a href='https://getpolis.ru/osago_contacts' target='_blank'>офис</a> или воспользоваться услугой вызова агента по тел. <a href='tel:+78002010643'>+7 800 201 06 43</a>"
                    />
                </p>
            </v-flex>

<!--
            <v-flex xs12 md5 py-0 v-if="alertText">
                <p :class="alertColor ? 'polis-text text-' + alertColor : 'polis-text'">{{alertText}}</p>
            </v-flex>
-->         <v-flex xs12 sm6 md3 pt-0>
            <v-select
                    v-if="!isEgarant"
                    label="Цель использования"
                    v-model="childUsagePurpose"
                    :rules="[rules.required]"
                    :items="usagePurposesArray"
                    item-value="id"
                    item-text="value"
                    class="pt-0"
                    no-data-text="Не удалось найти цели использования"
                    @change="dataChanged"
                    required
                />
            </v-flex>
            <v-flex md12 py-0>
                <v-select
                    v-if="isEgarant"
                    v-model="childUseType"
                    label="Цель использования"
                    :rules="[rules.required]"
                    :items="useTypes"
                    item-value="id"
                    item-text="value"
                    class="mt-0"
                    no-data-text="Не удалось найти цели использования"
                    @change="dataChanged"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import moment from "moment";

export default {
    name: "OsagoInsuranceConditions",
    props: [
        'dateStart',
        'dateMin',
        'dateStartMax',
        'dateStartMinEgarant',
        'usagePurposes',
        'usagePurpose',
        'useType',
        'useTypes',
        'rules',
        'term',
        'dateOldPolis',
        'osagoCompanyName',
        'rsaInfoLoading',
        'isEgarant',
        'alertText',
        'alertColor'
    ],
    data: () => ({
        // childUseTargetPersonal: false,
        childUsagePurpose: null,
        childUseType: null,
        childDateStart: null,
        childTerm: 12,
        childRsaInfoLoading: false,
        usagePurposesArray: [],
    }),
    mounted() {
        // value из объекта usagePurposes в новый массив
        this.usagePurposesArray = Object.entries(this.usagePurposes).map((e) => ({ id: e[0], value: e[1] }))
        this.childDateStart = this.dateStart;
        this.childTerm = this.term;
        this.childUsagePurpose = this.usagePurpose;
        this.childUseType = this.useType;
    },
    watch: {
        rsaInfoLoading() {
            this.childRsaInfoLoading = this.rsaInfoLoading
            this.setAlert()
        },
        dateStart() {
            this.childDateStart = this.dateStart
        },
        usagePurpose() {
            this.childUsagePurpose = this.usagePurpose
            this.dataChanged()
        },
    },
    methods: {
        dataChanged() {
            this.$emit('changeInsuranceConditionsData', {
                dateStart: this.childDateStart,
                term: this.childTerm,
                usagePurpose: this.childUsagePurpose,
                useType: this.childUseType,
                dateOldPolis: this.dateOldPolis,
                osagoCompanyName: this.osagoCompanyName
            })
        },
        setAlert() {
            if (!this.osagoCompanyName) {
                this.$emit('changeTextAndColor', {
                    alertText: `Мы не нашли текущий полис на вашу машину. Штраф за езду без ОСАГО 800 руб.\r\nСкорее оформите полис.`,
                    alertColor: 'red',
                });
                this.dataChanged();
                return;
            }
            const today = moment().format('YYYY-MM-DD');
            if (this.dateOldPolis < today) {
                this.$emit('changeTextAndColor', {
                    alertText: `Ваш полис в ${this.osagoCompanyName}, истек ${moment(this.dateOldPolis).format('DD.MM.YYYY')} г. Штраф за езду без ОСАГО 800 руб.\r\nСкорее оформите полис.`,
                    alertColor: 'yellow',
                });
                this.dataChanged();
                return;
            }
            const dateMax = moment().add(59, 'days').format('YYYY-MM-DD');
            if (this.dateOldPolis > dateMax) {
                this.$emit('changeTextAndColor', {
                    alertText: `Ваш текущий полис в ${this.osagoCompanyName} заканчивается ${moment(this.dateOldPolis).format('DD.MM.YYYY')} г. Оформить новый полис можно не позже 60 дней от текущей даты.`,
                    alertColor: 'yellow',
                });
                this.dataChanged();
                return;
            }
            this.$emit('changeTextAndColor', {
                alertText: `Ваш текущий полис в ${this.osagoCompanyName} заканчивается ${moment(this.dateOldPolis).format('DD.MM.YYYY')} г. Рекомендуем установить дату начала полиса без перерыва, c ${moment(this.dateOldPolis).add(1, 'days').format('DD.MM.YYYY')}`,
                alertColor: 'green',
            });
            this.dataChanged();
        }
    }
}
</script>

<style scoped>
    .polis-text {
        white-space: pre-wrap;
        font-size: 14px;
        padding-top: 5px;
    }
    @media(min-width: 960px) {
        .polis-text {
            padding-top: 2px;
        }
    }
    .text-red {
        color: #ff5252;
    }
    .text-yellow {
        color: #b7b708;
    }
    .text-green {
        color: #00ba57;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/OsagoInsuranceConditions.vue